import { render, staticRenderFns } from "./LogHttp.vue?vue&type=template&id=2ef42d4d&scoped=true"
import script from "./LogHttp.vue?vue&type=script&lang=js"
export * from "./LogHttp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef42d4d",
  null
  
)

export default component.exports